export const DOCUMENTS = "DOCUMENTS";
export const DOCUMENTS_COUNT = "DOCUMENTS_COUNT";
export const DOCUMENT_SELECTED = "DOCUMENTS_SELECTED";
export const DOCUMENT_BUSY = "DOCUMENTS_BUSY";
